import { isPlatformBrowser } from '@angular/common'
import { Component, Inject, PLATFORM_ID } from '@angular/core'
@Component({
  selector: 'flowaccount-accountingfirm-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}


  functionPage(page) {
    if (isPlatformBrowser(this.platformId)) {
    }
  }
}
